export function getBase64(file: Blob): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export async function dataUrlToArrayBuffer(
  dataUrl: string
): Promise<ArrayBuffer> {
  const res = await fetch(dataUrl);
  return res.arrayBuffer();
}

/** setTimeout wrapped in Promise
 *
 * Usage: await sleep(milliseconds);
 */
export function sleep(ms?: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const handle_db_name = (url: string, DB_PATH?: string): string => {
  return DB_PATH ? `${DB_PATH}/${url}` : `${url}`;
};

/** Type guard to filter out null and undefined values from an array
 *
 * Usage: array.filter(isNotNull)
 */
export const isNotNull = <T>(v: T | null | undefined): v is T => v != null;

/** Safely stringify a value to JSON, returning a string
 * even if it fails due to circular references or other issues.
 */
export function safeJSONStringify(value: unknown): string {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}
